<template><fleet-list kind="device" v-bind="$props"></fleet-list></template>
<script>
import FleetList from '../FleetList/index.vue'
import props from '../FleetList/props'
export default { name: 'avue-echart-deviceList', mixins: [props], components: { FleetList } }
</script>
